import { makeStyles } from "@material-ui/styles"
import { MAX_PAGE_WIDTH } from "@styles/themes";
import { CELL_WIDTHS } from "@utils";

const useStyle = makeStyles((theme) => ({
  root: {
    "&:not(.pdf-mode):not(.preview-mode):not(.printer-mode)": {
      maxWidth: "100vw",
    },
    "&.pdf-mode &.preview-mode": {
      maxWidth: MAX_PAGE_WIDTH,
    },
  },
  collapse: {
    width: "100%",
    "&:not(.pdf-mode):not(.preview-mode):not(.printer-mode)": {
      maxWidth: "100%",
    },
    "&.pdf-mode &.preview-mode": {
      maxWidth: MAX_PAGE_WIDTH,
    },
  },
  tableTitle: {
    marginTop: 16,
    minHeight: 48,
    "&:not(.pdf-mode):not(.preview-mode):not(.printer-mode)": {
      maxWidth: "100%",
    },
    "&.pdf-mode &.preview-mode": {
      maxWidth: MAX_PAGE_WIDTH,
    },
  },
  tableTitleExpandButton: {
    width: 32,
    marginRight: 8,
  },
  tableContainerWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  tableContainer: {
    width: `calc(100% + ${CELL_WIDTHS.DRAG_HANDLE}px) !important`,
    marginLeft: -CELL_WIDTHS.DRAG_HANDLE,
    marginBottom: 16,
  },
  buttonSwitch: {
    marginLeft: 16,
  },
  whiteContainer: {
    width: "100%",
    paddingTop: 24,
    paddingLeft: 48,
    paddingRight: 48,
    margin: "0 -48px",
    backgroundColor: theme.props.backgroundSecondary,
    boxSizing: "content-box",
  },
  whiteContainerFirst: {
    paddingBottom: 24,
    borderTop: "1px solid " + theme.props.border,
  },
  whiteContainerLast: {
    paddingBottom: 24,
    borderBottom: "1px solid " + theme.props.border,
  },
  paddingBottom: {
    paddingBottom: "76px !important",
  },
  
}));

export default useStyle;
